import axios from 'axios'

const VITE_API_URL = import.meta.env.VITE_API_URL

const axiosReconhecimento = axios.create({
  baseURL: VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export async function buscarRegistroCRC(payload) {
  try {
    const response = await axiosReconhecimento.post('/crc/obter-registro', payload)

    return response.data
  } catch (error) {
    console.error('Erro ao buscar registro CRC:', error)
    throw new Error(error?.response?.data?.message || 'Erro ao buscar registro CRC')
  }
}

export async function obterRegistroFiliacao(cpfFiliacao) {
  try {
    const response = await axiosReconhecimento.post('/crc/obter-filiacao', {
      cpfFiliacao,
    })

    return response.data
  } catch (error) {
    console.error('Erro ao obter registro de filiação:', error)
    throw new Error(error?.response?.data?.message || 'Erro ao obter registro de filiação')
  }
}